import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";

import yup from "../../utils/yup";
import Form from "../../components/form/Form";
import { changePassword } from "../../services/UserService";
import AppModal from "../../components/Modal";

const ChangePasswordFormModal = ({ open, onClose }) => {
  const passwordChangeSchema = yup
    .object()
    .shape({
      password1: yup
        .string("The password is not valid.")
        .required("Please enter your password.")
        .min(8, "The password must be at least 8 characters long.")
        .matches(
          /[a-z]+/,
          "The password must contain at least one lowercase character."
        )
        .matches(
          /[A-Z]+/,
          "The password must contain at least one uppercase character."
        )
        .matches(/\d+/, "The password must contain at least one number."),
      password2: yup
        .string("The repeat password is not valid.")
        .required("Please enter your password again.")
        .oneOf([yup.ref("password1")], "Your passwords do not match."),
    })
    .required();

  const passwordChangeForm = useForm({
    resolver: yupResolver(passwordChangeSchema),
    mode: "onChange",
  });

  const passwordChangeSteps = {
    submitButtonLabel: "Change",
    steps: [
      {
        name: "password1",
        label: "Password",
        htmlType: "password",
      },
      {
        name: "password2",
        label: "Repeat password",
        htmlType: "password",
      },
    ],
  };

  const onSubmit = (values) => {
    changePassword(passwordChangeForm.setError)(values).then(() => {
      toast.success("Your password has been changed.");
      passwordChangeForm.reset();
      onClose();
    });
  };

  return (
    <AppModal open={open} onClose={onClose} title="Change your password">
      <Form
        formDetails={passwordChangeSteps}
        form={passwordChangeForm}
        onSubmit={onSubmit}
        additionalButtons={
          <Button onClick={onClose} className="mt-4" variant="outline-danger">
            Close
          </Button>
        }
      />
    </AppModal>
  );
};

export default ChangePasswordFormModal;
